var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "info" },
    [
      _c("div", { staticClass: "info__title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("info_1")) + "\n  ")
      ]),
      _c(
        "router-link",
        { attrs: { to: { name: "about" } } },
        [
          _c("button-view", { attrs: { variant: "primary" } }, [
            _vm._v("\n      " + _vm._s(_vm.$t("button_2")) + "\n    ")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c5f54d3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c5f54d3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/info-view.vue
// module id = 412
// module chunks = 51